import React from "react"
import MoneyFortune from "@/containers/MoneyFortune"

import {
  QuestionsData,
  resultRoleJudge,
  getTraitId
} from "@/containers/MoneyFortune/money-fortune-data/QuestionsData"

import {
  ResultDate,
  GetAndShare
} from "@/containers/MoneyFortune/money-fortune-data/ResultData"

export default function Index() {
  return (
    <MoneyFortune
      QuestionsData={QuestionsData}
      ResultDate={ResultDate}
      resultRoleJudge={resultRoleJudge}
      GetAndShare={GetAndShare}
      API={GetAndShare.API}
      getTraitId={getTraitId}
    />
  )
}
